module.exports = __webpack_public_path__ + "static/media/favicon.d6b08afa.ico";